import { chakra } from '@chakra-ui/react';

const BaseButton = chakra('button');

export default BaseButton;
